module.exports = __webpack_public_path__ + "img/bewohner-hinzuefuegen.7636f28c.svg";